/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Describes available behaviors for the ValueOverlay.
 */
export var ValueLayerValueMode = /*@__PURE__*/ (function (ValueLayerValueMode) {
    /**
     * The layer will automatically choose a mode to use.
     */
    ValueLayerValueMode[ValueLayerValueMode["Auto"] = 0] = "Auto";
    /**
     * The layer will position itself at the minimum value found on the target series or across all series if no target is specified.
     */
    ValueLayerValueMode[ValueLayerValueMode["Minimum"] = 1] = "Minimum";
    /**
     * The layer will position itself at the maximum value found on the target series or across all series if no target is specified.
     */
    ValueLayerValueMode[ValueLayerValueMode["Maximum"] = 2] = "Maximum";
    /**
     * The layer will position itself at the average value found on the target series or at multiple values for multiple series if no target series is specified.
     */
    ValueLayerValueMode[ValueLayerValueMode["Average"] = 3] = "Average";
    /**
     * The layer will position itself at the global minimum value found.
     */
    ValueLayerValueMode[ValueLayerValueMode["GlobalMinimum"] = 4] = "GlobalMinimum";
    /**
     * The layer will position itself at the global maximum value found.
     */
    ValueLayerValueMode[ValueLayerValueMode["GlobalMaximum"] = 5] = "GlobalMaximum";
    /**
     * The layer will position itself at the global average value found.
     */
    ValueLayerValueMode[ValueLayerValueMode["GlobalAverage"] = 6] = "GlobalAverage";
    return ValueLayerValueMode;
})({});
/**
 * @hidden
 */
export var ValueLayerValueMode_$type = /*@__PURE__*/ markEnum('ValueLayerValueMode', 'Auto,0|Minimum,1|Maximum,2|Average,3|GlobalMinimum,4|GlobalMaximum,5|GlobalAverage,6');
